import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "py-8 text-center"
}
const _hoisted_2 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_3 = { class: "mt-2 space-y-2" }
const _hoisted_4 = { class: "flex items-center gap-2 text-sm text-gray-600" }
const _hoisted_5 = { class: "flex items-center gap-2 text-sm text-gray-600" }
const _hoisted_6 = { class: "flex items-center gap-2 text-sm text-gray-600" }
const _hoisted_7 = {
  key: 0,
  class: "text-sm text-red-500"
}

import {
		CheckCircleIcon
	} from "@heroicons/vue/24/outline"

	import {
		ref
	} from "vue"

	import {
		store as useUserStore
	} from "@/store/user"

	import api from "@/utilities/api"

	
	const __default__ = { name: "NewsletterModal" } // name the component

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {

	const userStore = useUserStore()

	const modal = ref<{open: boolean}>({open: false})
	const submitting = ref(false)
	const submitted = ref(false)
	const error = ref(false)
	const email = ref("")
	const firstName = ref("")
	const lastName = ref("")
	const company = ref("")
	const city = ref("")
	const state = ref("")
	const interestFileMaker = ref(false)
	const interestSalesforce = ref(false)
	const interestWebDevelopment = ref(false)

	// fill the form with whatever profile details we already have for the logged-in user
	function prefillFromUser() {
		const attributes = userStore?.user?.cognitoUser?.attributes || {}
		const address = JSON.parse(attributes.address || "{}")

		email.value = attributes.email || ""
		firstName.value = attributes.given_name || ""
		lastName.value = attributes.family_name || ""
		company.value = attributes["custom:company"] || ""
		city.value = address.locality || ""
		state.value = address.region || ""
	}

	// reveal the modal with a fresh, unsubmitted form
	function open() {
		submitting.value = false
		submitted.value = false
		error.value = false
		prefillFromUser()
		modal.value.open = true
	}

	// submits the form to the backend, which relays it to Mailchimp
	async function onSubmit(event: Event) {
		event.preventDefault()
		submitting.value = true
		error.value = false

		const interests = []

		if (interestFileMaker.value) {
			interests.push("fileMaker")
		}

		if (interestSalesforce.value) {
			interests.push("salesforce")
		}

		if (interestWebDevelopment.value) {
			interests.push("webDevelopment")
		}

		try {
			await api("post", "fmDataAPI", "/newsletter-subscribe", {
				email: email.value,
				firstName: firstName.value,
				lastName: lastName.value,
				company: company.value,
				city: city.value,
				state: state.value,
				interests
			})

			submitted.value = true
		}
		catch (e) {
			error.value = true
		}
		finally {
			submitting.value = false
		}
	}

	__expose({
		open
	})

return (_ctx: any,_cache: any) => {
  const _component_tw_button = _resolveComponent("tw-button")!
  const _component_tw_modal = _resolveComponent("tw-modal")!

  return (_openBlock(), _createBlock(_component_tw_modal, {
    title: "Subscribe to Our Newsletter",
    "modal-max-width": "max-w-md",
    ref_key: "modal",
    ref: modal
  }, {
    default: _withCtx(() => [
      (submitted.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(CheckCircleIcon), { class: "mx-auto h-10 w-10 text-green-500" }),
            _cache[7] || (_cache[7] = _createElementVNode("p", { class: "mt-3 text-sm text-gray-600" }, "Thanks for subscribing!", -1))
          ]))
        : (_openBlock(), _createElementBlock("form", {
            key: 1,
            class: "py-4 space-y-4",
            onSubmit: onSubmit
          }, [
            _createElementVNode("div", null, [
              _cache[8] || (_cache[8] = _createElementVNode("label", {
                for: "newsletter-email",
                class: "block text-sm font-medium text-gray-700"
              }, [
                _createTextVNode("Email Address "),
                _createElementVNode("span", { class: "text-red-500" }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                id: "newsletter-email",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                type: "email",
                required: "",
                class: "mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              }, null, 512), [
                [_vModelText, email.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", null, [
                _cache[9] || (_cache[9] = _createElementVNode("label", {
                  for: "newsletter-fname",
                  class: "block text-sm font-medium text-gray-700"
                }, "First Name", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "newsletter-fname",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((firstName).value = $event)),
                  type: "text",
                  class: "mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                }, null, 512), [
                  [_vModelText, firstName.value]
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[10] || (_cache[10] = _createElementVNode("label", {
                  for: "newsletter-lname",
                  class: "block text-sm font-medium text-gray-700"
                }, "Last Name", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "newsletter-lname",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((lastName).value = $event)),
                  type: "text",
                  class: "mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                }, null, 512), [
                  [_vModelText, lastName.value]
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[11] || (_cache[11] = _createElementVNode("label", {
                for: "newsletter-company",
                class: "block text-sm font-medium text-gray-700"
              }, "Company", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "newsletter-company",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((company).value = $event)),
                type: "text",
                class: "mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              }, null, 512), [
                [_vModelText, company.value]
              ])
            ]),
            _createElementVNode("fieldset", null, [
              _cache[15] || (_cache[15] = _createElementVNode("legend", { class: "block text-sm font-medium text-gray-700" }, "Interests", -1)),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("label", _hoisted_4, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((interestFileMaker).value = $event)),
                    type: "checkbox",
                    class: "rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                  }, null, 512), [
                    [_vModelCheckbox, interestFileMaker.value]
                  ]),
                  _cache[12] || (_cache[12] = _createTextVNode(" FileMaker "))
                ]),
                _createElementVNode("label", _hoisted_5, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((interestSalesforce).value = $event)),
                    type: "checkbox",
                    class: "rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                  }, null, 512), [
                    [_vModelCheckbox, interestSalesforce.value]
                  ]),
                  _cache[13] || (_cache[13] = _createTextVNode(" Salesforce "))
                ]),
                _createElementVNode("label", _hoisted_6, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((interestWebDevelopment).value = $event)),
                    type: "checkbox",
                    class: "rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                  }, null, 512), [
                    [_vModelCheckbox, interestWebDevelopment.value]
                  ]),
                  _cache[14] || (_cache[14] = _createTextVNode(" Web Development "))
                ])
              ])
            ]),
            (error.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, "Something went wrong subscribing you. Please try again."))
              : _createCommentVNode("", true),
            _createVNode(_component_tw_button, {
              type: "submit",
              class: "btn-base btn-indigo mt-2 w-full",
              loading: submitting.value,
              disabled: submitting.value
            }, {
              default: _withCtx(() => _cache[16] || (_cache[16] = [
                _createTextVNode(" Subscribe ")
              ])),
              _: 1,
              __: [16]
            }, 8, ["loading", "disabled"])
          ], 32))
    ]),
    _: 1
  }, 512))
}
}

})